import m from "../../geodata/es2015/maldivesIslandsHigh";
window.am4geodata_maldivesIslandsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maldivesIslandsHigh.js
// module id = null
// module chunks = 